<template>
  <div>
    <a-modal
      :visible="visible"
      title="编辑预警规则"
      width="920px"
      class="warmModal"
      centered
      @ok="setMonitor"
      @cancel="handleCancel"
    >
      <div class="confBlock">
        <span class="cofBlockName">预警范围</span>
        <div class="confContent">
          <div class="confLine">
            <span class="confLable">营销目标</span>
            <div class="confLineC">
              <a-radio-group v-model="marketing_goal" :disabled="true">
                <a-radio-button
                  :value="item.value"
                  v-for="item in markePurposeLis"
                  :key="item.name"
                >
                  {{ item.name }}
                </a-radio-button>
              </a-radio-group>
            </div>
          </div>
          <div class="confLine fxStart">
            <span class="confLable"> 监控账户 </span>
            <div class="confLineC" style="line-height: 32px">
              {{ advertiser_id }}
            </div>
          </div>

          <!-- <div class="confLine fxStart" v-if="marketing_goal=='VIDEO_PROM_GOODS'">
          <span class="confLable">
            监控计划
          </span>
          <div class="confLineC" style="line-height: 32px;">
            <a-tag>{{ ad_id }}</a-tag>
          </div>
        </div> -->
          <!-- <div class="confLine fxStart" v-if="marketing_goal=='LIVE_PROM_GOODS'">
          <span class="confLable">
            监控对象
          </span>
          <div class="confLineC" style="line-height: 32px;">
            {{ aweme_name }} (ID:{{ aweme_id }})
          </div>
        </div> -->

          <div class="confLine fxStart">
            <span class="confLable"> 数据范围 </span>
            <div class="confLineC">
              <a-select
                v-model="warnCondition.day"
                style="width: 200px; color: red"
                :disabled="true"
              >
                <a-select-option value="1">当日数据</a-select-option>
                <!-- <a-select-option value="3" >近3天数据</a-select-option>
                <a-select-option value="7" >近7天数据</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
      </div>

      <div style="max-height: 800px; overflow: auto">
        <!-- 预警内容 -->

        <div class="confBlock">
          <span class="cofBlockName"
            >监控指标<a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.diy_open == 1"
              @change="warnCondition.diy_open = !warnCondition.diy_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.diy_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  <a-select
                    v-model="warnCondition.diy_json.x"
                    style="width: 100px"
                    placeholder="请选择"
                    @change="changeX"
                  >
                    <a-select-option
                      v-for="item in xData"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy_json.x_relation"
                    style="margin: 0 10px"
                    @change="handleXChange"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy_json.x_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  />
                  且
                  <a-select
                    v-model="warnCondition.diy_json.y"
                    style="width: 100px"
                    placeholder="请选择"
                    @change="changeY"
                  >
                    <a-select-option
                      v-for="item in yData"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy_json.y_relation"
                    style="margin: 0 10px"
                    @change="handleYChange"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy_json.y_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                <a-select
                  :value="warnCondition.diy_json.action"
                  style="width: 200px"
                  @change="handleDiyChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxdelete"
                    >微信通知且自动删除素材</a-select-option
                  >
                </a-select>
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.diy_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.diy_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock" v-if="marketing_goal == 'VIDEO_PROM_GOODS'">
          <span class="cofBlockName"
            >监控标签
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.bq_open == 1"
              @change="warnCondition.bq_open = !warnCondition.bq_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.bq_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  <a-checkbox-group
                    v-model="warnCondition.bq_json.analysis_type"
                  >
                    <a-checkbox value="LOW_QUALITY_MATERIAL">
                      低质素材
                    </a-checkbox>
                    <a-checkbox value="INEFFICIENT_MATERIAL">
                      低效素材
                    </a-checkbox>
                    <a-checkbox value="CARRY_MATERIAL"> 搬运素材 </a-checkbox>
                    <a-checkbox value="SIMILAR_MATERIAL">
                      同质化素材
                    </a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                <a-select
                  :value="warnCondition.bq_json.action"
                  style="width: 200px"
                  @change="handleBqChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="delete">自动删除素材</a-select-option>
                  <a-select-option value="wxdelete"
                    >微信通知且自动删除素材</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.bq_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.bq_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >监控状态
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.reject_open == 1"
              @change="warnCondition.reject_open = !warnCondition.reject_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.reject_open == 1">
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: red; font-weight: bold">
                自动删除审核不通过的素材
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >广告审核建议
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.suggestion_open == 1"
              @change="
                warnCondition.suggestion_open = !warnCondition.suggestion_open
              "
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.suggestion_open == 1">
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: red; font-weight: bold">
                自动删除出现广告审核建议的素材
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >内容审核建议
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.suggestion_nr_open == 1"
              @change="
                warnCondition.suggestion_nr_open = !warnCondition.suggestion_nr_open
              "
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.suggestion_nr_open == 1">
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: red; font-weight: bold">
                自动删除出现内容审核建议的素材
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock" v-if="false">
          <span class="cofBlockName"
            >采集审核建议
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.collect_open == 1"
              @change="warnCondition.collect_open = !warnCondition.collect_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.collect_open == 1">
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: red; font-weight: bold">
                自动采集审核建议的素材数据
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >追投关停
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.ztgt_open == 1"
              @change="warnCondition.ztgt_open = !warnCondition.ztgt_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.ztgt_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  【调控支付ROI】小于
                  <a-input
                    v-model="warnCondition.ztgt_json.roi"
                    class="conditionInput"
                    placeholder="请输入支付ROI"
                  />
                  (且)【调控消耗】大于
                  <a-input-number
                    placeholder="消耗"
                    v-model="warnCondition.ztgt_json.stat_cost"
                    :min="0.01"
                    :max="10000"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  v-model="warnCondition.ztgt_json.action"
                  style="width: 200px"
                  @change="handleZtgtChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxstop"
                    >微信通知且自动终止调控</a-select-option
                  >
                </a-select>
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >素材调控
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.sczt_open == 1"
              @change="warnCondition.sczt_open = !warnCondition.sczt_open"
            />
            <b style="margin-left: 10px; color: red;margin-right: 10px;">New</b>(当投放中计划对应达人抖音下有发布视频时)
          </span>
          <div class="confContent" v-if="warnCondition.sczt_open == 1">
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: red; font-weight: bold">
                <a-radio-group v-model="warnCondition.sczt_json.action">
                  <a-radio value="wxadd">补当日素材进计划且通知 </a-radio>
                  <a-radio value="wxadd4">补近4日素材进计划且通知 </a-radio>
                  <a-radio value="wxadd10">补近10日素材进计划且通知 </a-radio>
                  <a-radio value="wxno">补当日进计划且不通知 </a-radio>
                  <a-radio value="wxzt">补当日素材进计划且进行追投 </a-radio>
                  <a-radio value="wxadd180">补180天前素材（联系客服） </a-radio>
                </a-radio-group>
              </div>
            </div>
            <div
              class="confLine"
              v-if="warnCondition.sczt_json.action == 'wxzt'"
            >
              <span class="confLable">追投配置：</span>
              <div class="confLineC">
                <div>
                  <div class="title-box level-2 normal">
                    调控时长
                    (可设范围0.5-24小时。注意：有起量需求时，建议提前10分钟创建任务)
                  </div>
                  <div class="external-action-wrapper" style="text-align: left">
                    <a-input
                      v-model="warnCondition.sczt_json.duration"
                      placeholder="调控时长"
                      style="width: 130px"
                    >
                      <div
                        slot="addonBefore"
                        style="cursor: pointer"
                        @click="onDurationDrop"
                      >
                        <a-icon type="minus" />
                      </div>
                      <div
                        slot="addonAfter"
                        style="cursor: pointer"
                        @click="onDurationRise"
                      >
                        <a-icon type="plus" />
                      </div>
                    </a-input>

                    <span
                      style="
                        margin-left: 10px;
                        font-size: 16px;
                        line-height: 30px;
                      "
                    >
                      小时</span
                    >
                  </div>

                  <div class="title-box level-2 normal">
                    调控预算
                    (调控预算为额外追加的独立预算，调控预算越高ROI下降风险越大，且不支持成本保障，请合理设置)
                  </div>
                  <div class="delivery-schedule-wrapper">
                    <div class="container interval normal">
                      <a-radio-group
                        :value="warnCondition.sczt_json.budget"
                        @change="handleRenewalBudgetChange"
                      >
                        <a-radio-button value="100"> 100元 </a-radio-button>
                        <a-radio-button value="200"> 200元 </a-radio-button>
                        <a-radio-button value="500"> 500元 </a-radio-button>
                        <a-radio-button value="1000"> 1000元 </a-radio-button>
                        <a-radio-button value="2000"> 2000元 </a-radio-button>
                        <a-radio-button value="-1"> 自定义 </a-radio-button>
                      </a-radio-group>
                      <a-input-number
                        :min="10"
                        :max="50000"
                        placeholder="最低10元"
                        v-model="warnCondition.sczt_json.diyamount"
                        v-if="warnCondition.sczt_json.budget == '-1'"
                        class="cpa_bid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >高产复投
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.gcft_open == 1"
              @change="warnCondition.gcft_open = !warnCondition.gcft_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div
            class="confContent gcft-config"
            v-if="warnCondition.gcft_open == 1"
          >
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  【支付ROI】大于
                  <a-input
                    v-model="warnCondition.gcft_json.roi"
                    class="conditionInput"
                    placeholder="请输入支付ROI"
                    @blur="
                      (e) => {
                        validateRoiInput(e.target.value);
                        warnCondition.gcft_json.roi = formatNumber(
                          e.target.value,
                          2
                        );
                      }
                    "
                  />
                  (且)【消耗】大于
                  <a-input-number
                    placeholder="消耗"
                    v-model="warnCondition.gcft_json.stat_cost"
                    :min="1"
                    :max="10000"
                    @blur="
                      (e) => {
                        validateCostInput(e.target.value);
                        warnCondition.gcft_json.stat_cost = formatNumber(
                          e.target.value,
                          0
                        );
                      }
                    "
                  />
                </div>
                <div
                  class="hintBlock"
                  style="color: #666; font-size: 12px; margin-top: 8px"
                >
                  说明：当计划满足支付ROI和消耗条件时，系统将自动执行相应操作
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作：</span>
              <div class="confLineC" style="color: green; font-weight: bold">
                微信通知且自动复投一笔
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">追投配置：</span>
              <div class="confLineC">
                <div>
                  <div class="title-box level-2 normal">
                    调控时长
                    (可设范围0.5-24小时。注意：有起量需求时，建议提前10分钟创建任务)
                  </div>
                  <div class="external-action-wrapper" style="text-align: left">
                    <a-input
                      v-model="warnCondition.gcft_json.duration"
                      placeholder="调控时长"
                      style="width: 130px"
                    >
                      <div
                        slot="addonBefore"
                        style="cursor: pointer"
                        @click="onGcftDurationDrop"
                      >
                        <a-icon type="minus" />
                      </div>
                      <div
                        slot="addonAfter"
                        style="cursor: pointer"
                        @click="onGcftDurationRise"
                      >
                        <a-icon type="plus" />
                      </div>
                    </a-input>

                    <span
                      style="
                        margin-left: 10px;
                        font-size: 16px;
                        line-height: 30px;
                      "
                    >
                      小时</span
                    >
                  </div>

                  <div class="title-box level-2 normal">
                    调控预算
                    (调控预算为额外追加的独立预算，调控预算越高ROI下降风险越大，且不支持成本保障，请合理设置)
                  </div>
                  <div class="delivery-schedule-wrapper">
                    <div class="container interval normal">
                      <a-radio-group
                        :value="warnCondition.gcft_json.budget"
                        @change="handleGcftBudgetChange"
                      >
                        <a-radio-button value="100"> 100元 </a-radio-button>
                        <a-radio-button value="200"> 200元 </a-radio-button>
                        <a-radio-button value="500"> 500元 </a-radio-button>
                        <a-radio-button value="1000"> 1000元 </a-radio-button>
                        <a-radio-button value="2000"> 2000元 </a-radio-button>
                        <a-radio-button value="-1"> 自定义 </a-radio-button>
                      </a-radio-group>
                      <a-input-number
                        :min="10"
                        :max="50000"
                        placeholder="最低10元"
                        v-model="warnCondition.gcft_json.diyamount"
                        v-if="warnCondition.gcft_json.budget == '-1'"
                        class="cpa_bid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 
    <div class="confBlock">
      <span class="cofBlockName">关停账户计划 <a-switch checked-children="开" un-checked-children="关" :checked="warnCondition.ad_close==1"  @change="warnCondition.ad_close = !warnCondition.ad_close"/> <b style="margin-left:10px;color:red">New</b> </span>
      <div class="confContent"  v-if="warnCondition.ad_close == 1"> 
        <div class="confLine">
          <span class="confLable">执行操作：</span>
          <div class="confLineC" style="color: red;font-weight: bold;"> 
              当账户下某一条计划的素材审核通过后，
                <a-radio-group v-model="warnCondition.ad_close_type">
                  <a-radio value="ONE">
                    关停素材对应的单条计划
                  </a-radio>
                  <a-radio value="ALL">
                    关停账户所有计划
                  </a-radio>
                </a-radio-group> 

          </div>
        </div>  
      </div>
    </div> -->
      </div>

      <div style="font-size: 12px; color: #999">
        免责声明：尊敬的用户，因自动化预警功能的实现需要抖音官方Markting API
        接口返回数据，如因官方接口返回数据或其他数据异常导致执行操作错误，抖川助手不承担任何法律责任。
      </div>
    </a-modal>

    <!-- <a-drawer v-if="adDrawer" class="authAccount" title="选择计划" width="70%" placement="right" :visible="adDrawer" @close="adDrawer = false">
      <div class="searchResult"> 
        <AdVideoList ref="adlist" :selectKeys="warnCondition.zdyj_json.ad_ids||[]" v-if="marketing_goal=='VIDEO_PROM_GOODS'" :marketing_goal="marketing_goal" :advertiser_id="advertiser_id" @selectAdDrawer="selectAdDrawer" @closeAdDrawer="closeAdDrawer"/>
        <AdLiveList ref="adlist" :selectKeys="warnCondition.zdyj_json.ad_ids||[]" v-if="marketing_goal=='LIVE_PROM_GOODS'" :marketing_goal="marketing_goal" :advertiser_id="advertiser_id" @selectAdDrawer="selectAdDrawer"  @closeAdDrawer="closeAdDrawer"/>
      </div>
    </a-drawer> -->
  </div>
</template>
<script>
import { qcApi, requestHttp, isNumber } from '@utils/index';
import { number } from 'echarts';
// import awemeList from '../../batchCreatePlan/components/awemeList.vue';
// import AdVideoList from '../../components/adVideoList.vue';
// import AdLiveList from '../../components/adLiveList.vue';
import moment from 'moment';
import { Modal } from 'ant-design-vue';
export default {
  name: 'warnRuleModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    advertiserList: {
      type: Array,
    },
    advertiser_id: {
      type: String,
      default: '',
    },
    marketing_goal: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    new_ad_id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      markePurposeLis: [
        {
          name: '推商品',
          value: 'VIDEO_PROM_GOODS',
        },
        {
          name: '推直播',
          value: 'LIVE_PROM_GOODS',
        },
      ],
      xData: [
        {
          value: '0',
          name: 'stat_cost_for_roi2',
          label: '消耗',
          disabled: false,
        },
        {
          value: '1',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: true,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
      ],
      yData: [
        {
          value: '0',
          name: 'stat_cost_for_roi2',
          label: '消耗',
          disabled: true,
        },
        {
          value: '1',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
      ],
      start_open: false,
      end_open: false,
      ad_id: '',
      warnCondition: {
        day: '1',
        diy_open: 1,
        diy_json: {
          x: 'stat_cost_for_roi2',
          x_value: '',
          x_relation: '>',
          y: 'total_prepay_and_pay_order_roi2',
          y_value: '',
          y_relation: '<',
          action: 'wx',
          start: '',
          end: '',
        },
        bq_open: 0,
        bq_json: {
          analysis_type: ['LOW_QUALITY_MATERIAL'],
          action: 'wx',
          start: '',
          end: '',
        },
        ztgt_open: 0,
        ztgt_json: {
          action: 'wxstop',
          stat_cost: '',
          roi: '',
        },
        sczt_open: 0,
        sczt_json: {
          action: 'wxzt',
          budget: '100',
          duration: '12',
          diyamount: '',
        },
        gcft_open: 0,
        gcft_json: {
          action: 'wxzt',
          budget: '100',
          duration: '12',
          diyamount: '',
          roi: '',
          stat_cost: '',
        },
        collect_open: 0,
        ad_close: 0,
        ad_close_type: 'ONE',
        reject_open: 0,
        suggestion_open: 0,
        suggestion_nr_open: 0,
      },
      aweme_name: '',
      aweme_id: '',
      aweme_avatar: '',
      anchor_id: '',

      adDrawer: false,
      pz: '',
      stop_time_open: false,
    };
  },

  components: {
    // AwemeList: awemeList,
    // AdVideoList,
    // AdLiveList
  },

  watch: {},
  mounted() {
    console.log('advertiser_id______', this.advertiser_id);
    if (this.new_ad_id) {
      this.ad_id = this.new_ad_id;
    }
    this.getMonitorDetail();
    // this.advertiser_id = this.advertiserList[0].advertiser_id
  },
  methods: {
    moment,
    handleRenewalBudgetChange(e) {
      this.warnCondition.sczt_json.budget = e.target.value;
    },
    onDurationDrop() {
      let duration = parseFloat(this.warnCondition.sczt_json.duration);
      if (duration < '0.5') {
        this.warnCondition.sczt_json.duration = '0';
        this.$message.warning('期望曝光时长不能低于0小时');
        return;
      } else {
        this.warnCondition.sczt_json.duration = duration - 0.5;
      }
    },
    onDurationRise() {
      let duration = parseFloat(this.warnCondition.sczt_json.duration);
      if (duration > '24') {
        this.warnCondition.sczt_json.duration = 24;
        this.$message.warning('期望曝光时长最大只能24小时');
      } else {
        this.warnCondition.sczt_json.duration = duration + 0.5;
      }
    },
    handleZtgtChange(e) {
      this.warnCondition.ztgt_json.action = e;
    },
    handleGcftBudgetChange(e) {
      this.warnCondition.gcft_json.budget = e.target.value;
    },
    onGcftDurationDrop() {
      let duration = parseFloat(this.warnCondition.gcft_json.duration);
      if (duration < '0.5') {
        this.warnCondition.gcft_json.duration = '0';
        this.$message.warning('调控时长不能低于0小时');
        return;
      } else {
        this.warnCondition.gcft_json.duration = duration - 0.5;
      }
    },
    onGcftDurationRise() {
      let duration = parseFloat(this.warnCondition.gcft_json.duration);
      if (duration > '24') {
        this.warnCondition.gcft_json.duration = 24;
        this.$message.warning('调控时长最大只能24小时');
      } else {
        this.warnCondition.gcft_json.duration = duration + 0.5;
      }
    },
    // 验证ROI输入格式
    validateRoiInput(value) {
      if (value && !isNumber(value)) {
        this.$message.warning('请输入有效的数字');
        return false;
      }
      return true;
    },
    // 验证消耗输入格式
    validateCostInput(value) {
      if (value && !isNumber(value)) {
        this.$message.warning('请输入有效的数字');
        return false;
      }
      if (value && parseFloat(value) < 0) {
        this.$message.warning('消耗不能为负数');
        return false;
      }
      return true;
    },
    // 格式化数值显示
    formatNumber(value, decimals = 2) {
      if (!value) return '';
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toFixed(decimals);
    },
    // 检查高产复投配置完整性
    checkGcftConfigComplete() {
      const config = this.warnCondition.gcft_json;
      if (!config.roi || !config.stat_cost) {
        return false;
      }
      if (!config.duration || config.duration < 0.5) {
        return false;
      }
      if (
        config.budget === '-1' &&
        (!config.diyamount || config.diyamount < 10)
      ) {
        return false;
      }
      return true;
    },
    selectAdDrawer(e) {
      console.log('父组件接收到的值', e);
      this.warnCondition[this.pz].ad_ids = e;
      this.adDrawer = false;
    },
    closeAdDrawer() {
      this.adDrawer = false;
    },
    changeX(value) {
      console.log('---', value);
      let rt = this.xData.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy_json.x = rt[0].name;
      let val = rt[0].value;
      this.yData.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    changeY(value) {
      console.log('---', value);
      let rt = this.yData.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy_json.y = rt[0].name;
      let val = rt[0].value;
      this.xData.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    handleDiyChange(e) {
      this.warnCondition.diy_json.action = e;
    },
    handleBqChange(e) {
      this.warnCondition.bq_json.action = e;
    },
    handleXChange(e) {
      this.warnCondition.diy_json.x_relation = e;
    },
    handleYChange(e) {
      this.warnCondition.diy_json.y_relation = e;
    },
    getAdvertiserId(advertiser_id) {
      console.log('子组件传回的值', advertiser_id);
      this.advertiser_id = advertiser_id;
      // this.getNearData()
    },
    async getMonitorDetail() {
      console.log('获取详情');
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_MATERIAL_MONITOR_DETAIL}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          id: this.id,
          ad_id: this.new_ad_id,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) {
        this.warnCondition = {
          day: '1',
          diy_open: 1,
          diy_json: {
            x: 'stat_cost_for_roi2',
            x_value: '',
            x_relation: '>',
            y: 'total_prepay_and_pay_order_roi2',
            y_value: '',
            y_relation: '<',
            action: 'wx',
            start: '',
            end: '',
          },
          bq_open: 0,
          bq_json: {
            analysis_type: ['LOW_QUALITY_MATERIAL'],
            action: 'wx',
            start: '',
            end: '',
          },
          ztgt_open: 0,
          ztgt_json: {
            action: 'wxstop',
            stat_cost: '',
            roi: '',
          },
          sczt_open: 0,
          sczt_json: {
            action: 'wxzt',
            budget: '100',
            duration: '12',
            diyamount: '',
          },
          gcft_open: 0,
          gcft_json: {
            action: 'wxzt',
            budget: '100',
            duration: '12',
            diyamount: '',
            roi: '',
            stat_cost: '',
          },
          collect_open: 0,
          ad_close: 0,
          ad_close_type: 'ONE',
          reject_open: 0,
          suggestion_open: 0,
          suggestion_nr_open: 0,
        };
        return;
      }

      this.warnCondition.day = data.day;
      this.warnCondition.diy_open = data.diy_open;

      this.warnCondition.bq_open = data.bq_open;
      this.warnCondition.ad_close = data.ad_close;
      this.warnCondition.ad_close_type = data.ad_close_type;
      this.warnCondition.reject_open = data.reject_open;
      this.warnCondition.ztgt_open = data.ztgt_open;
      this.warnCondition.suggestion_open = data.suggestion_open;
      this.warnCondition.suggestion_nr_open = data.suggestion_nr_open;
      this.warnCondition.collect_open = data.collect_open;
      this.warnCondition.sczt_open = data.sczt_open;
      this.warnCondition.gcft_open = data.gcft_open;

      this.ad_id = data.ad_id;
      this.aweme_name = data.aweme_name;
      this.aweme_id = data.aweme_id;
      this.aweme_avatar = data.aweme_avatar;
      this.anchor_id = data.anchor_id;

      if (data.diy_json) {
        this.warnCondition.diy_json = data.diy_json;
      }
      if (data.bq_json) {
        this.warnCondition.bq_json = data.bq_json;
      }
      if (data.ztgt_json) {
        this.warnCondition.ztgt_json = data.ztgt_json;
      }
      if (data.sczt_json) {
        this.warnCondition.sczt_json = data.sczt_json;
      }
      if (data.gcft_json) {
        this.warnCondition.gcft_json = data.gcft_json;
      }
      console.log('获取详情', this.warnCondition);
    },
    async setMonitor() {
      console.log(this.warnCondition);
      if (this.warnCondition.diy_open) {
        if (!this.warnCondition.diy_json) {
          this.$message.error('您已开启【自定义监控】配置，请配置参数');
          return;
        }
        if (this.warnCondition.diy_json.x_value == '') {
          this.$message.error('您已开启【自定义监控】配置，请设置参数1');
          return;
        }
        if (this.warnCondition.diy_json.y_value == '') {
          this.$message.error('您已开启【自定义监控】配置，请设置参数2');
          return;
        }
      }

      if (this.warnCondition.ztgt_open) {
        if (!this.warnCondition.ztgt_json) {
          this.$message.error('您已开启【追投关停监控】配置，请配置参数');
          return;
        }
        if (this.warnCondition.ztgt_json.roi == '') {
          this.$message.error('您已开启【追投关停监控】配置，请设置参数roi');
          return;
        }
        if (this.warnCondition.ztgt_json.stat_cost == '') {
          this.$message.error('您已开启【追投关停监控】配置，请设置参数消耗');
          return;
        }
      }
      if (this.warnCondition.gcft_open) {
        if (!this.warnCondition.gcft_json) {
          this.$message.error('您已开启【高产复投】配置，请配置参数');
          return;
        }
        if (this.warnCondition.gcft_json.roi == '') {
          this.$message.error('您已开启【高产复投】配置，请设置支付ROI参数');
          return;
        }
        if (this.warnCondition.gcft_json.stat_cost == '') {
          this.$message.error('您已开启【高产复投】配置，请设置消耗参数');
          return;
        }
        if (
          !this.warnCondition.gcft_json.duration ||
          this.warnCondition.gcft_json.duration < 0.5
        ) {
          this.$message.error(
            '您已开启【高产复投】自动追投，请设置调控时长（最低0.5小时）'
          );
          return;
        }
        if (
          this.warnCondition.gcft_json.budget == '-1' &&
          (!this.warnCondition.gcft_json.diyamount ||
            this.warnCondition.gcft_json.diyamount < 10)
        ) {
          this.$message.error(
            '您已开启【高产复投】自动追投，请设置调控预算（最低10元）'
          );
          return;
        }
      }
      Modal.confirm({
        title: '提示',
        content:
          '是否确认保存？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          this.loading = true;
          await this.setMonitorAction();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    async setMonitorAction() {
      let that = this;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SET_QY_MATERIAL_MONITOR}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          ad_id: this.ad_id,
          aweme_id: this.aweme_id,
          aweme_name: this.aweme_name,
          aweme_avatar: this.aweme_avatar,
          anchor_id: this.anchor_id,
          warnCondition: JSON.stringify(this.warnCondition),
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (code == 0) {
        this.$message.error(msg);
      } else {
        this.$emit('closeRuleModal');
        this.$message.success(msg);
      }
    },
    handleChange(e) {
      console.log(e);
      this.advertiser_id = e;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //修改营销目的
    markePurposeChange(e) {
      this.marketing_goal = e.target.value;
    },
    handleOk() {
      this.$emit('closeRuleModal');
    },

    handleCancel() {
      this.$emit('closeRuleModal');
    },
  },
};
</script>

<style lang="less" scoped>
.ant-switch {
  margin-left: 20px;
}
.ant-modal-body {
  padding: 10px 24px;
}
.confBlock {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 4px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  .cofBlockName {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &::before {
      content: '';
      width: 4px;
      height: 14px;
      background-color: #2b6afd;
      margin-right: 8px;
      display: inline-block;
    }
  }
  .confContent {
    margin-top: 20px;
  }
  .warnTypeBtn {
    margin-right: 10px;
    &.checked {
      border-color: #1890ff;
      color: #1890ff;
    }
  }
  .highlightTxt {
    color: #1890ff;
    font-size: 12px;
  }
  .confLine {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    &.fxStart {
      align-items: flex-start;
      .confLable {
        margin-top: 6px;
      }
    }
    .confLable {
      width: 90px;
      text-align: right;
      margin: 0px 10px 0 0;
    }
    .hintBlock {
      margin-top: 8px;
      font-size: 12px;
    }
    .conditionInput {
      width: 120px;
      margin-right: 10px;
    }
    .actionCondition {
      margin-bottom: 8px;
    }
  }
}
.tags-area-body {
  overflow-y: auto;
  // display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-content: flex-start;
  width: 720px;
  .tag {
    display: flex;
    align-items: center;
    width: 24%;
    float: left;
    height: 26px;
    overflow: hidden;
    background-color: #f2f2f2;
    border-radius: 4px;
    margin: 6px auto 0 6px;
    // margin-right: 10px;
    // margin-top: 10px;
    padding: 2px 6px;
    color: #999;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;

    .tag-icon {
      width: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
}

.title-box {
  line-height: 40px;
}

// 高产复投特定样式
.gcft-config {
  .conditionInput {
    width: 120px;
    margin-right: 10px;
  }

  .budget-options {
    margin-top: 8px;
  }

  .duration-control {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }

  .config-status {
    display: inline-flex;
    align-items: center;
    margin-left: 10px;

    &.warning {
      color: #ff4d4f;
    }

    &.success {
      color: #52c41a;
    }
  }
}
</style>
